<template>
  <Toast v-bind="$attrs" class="c-global-toast" :group="group" :baseZIndex="1">
    <template #closeicon>
      <X :size="24" :stroke-width="1.5" class="toast-close-icon" />
    </template>
    <template #icon>
      <component
        :is="icon"
        v-if="typeof icon !== 'string'"
        :size="24"
        :stroke-width="1.5"
        class="toast-message-icon shrink-0"
        :class="iconClass"
      >
        <template v-if="group === 'error' || group === 'scanner-error'" #default>
          <g class="origin-center scale-125">
            <path d="M12 16h.01" />
            <path d="M12 8v4" />
          </g>
        </template>
      </component>
      <span v-else class="toast-message-icon shrink-0 material-symbols-rounded">{{ icon }}</span>
    </template>
  </Toast>
</template>

<script setup lang="ts">
import { computed, type Component, type PropType } from 'vue';
import { X } from 'lucide-vue-next';

const props = defineProps({
  group: {
    type: String,
    required: true,
  },
  icon: {
    type: [String, Object, Function] as PropType<string | Component>,
    required: true,
  },
});

const iconClass = computed(() => {
  switch (props.group) {
    case 'success':
    case 'scanner-success':
      return '[&_circle]:fill-feedback-icon-success [&_circle]:stroke-feedback-icon-success [&_path]:stroke-feedback-surface-success [&_path]:fill-none [&_path]:[stroke-width:1.5px] [&_path]:origin-center [&_path]:scale-125';
    case 'error':
    case 'scanner-error':
      return '[&_path]:stroke-feedback-surface-danger [&_path]:fill-none [&_path]:[stroke-width:1.5px] [&_path:nth-child(3)]:fill-feedback-icon-danger [&_path:nth-child(3)]:stroke-feedback-icon-danger';
    case 'warn':
      return '[&_circle]:fill-feedback-icon-warn [&_circle]:stroke-feedback-icon-warn [&_line]:stroke-feedback-surface-warn [&_line]:fill-none [&_line]:[stroke-width:1.5px] [&_line]:origin-center [&_line]:scale-125';
    case 'info':
    default:
      return '[&_circle]:fill-feedback-icon-info [&_circle]:stroke-feedback-icon-info [&_path]:stroke-feedback-surface-info [&_path]:fill-none [&_path]:[stroke-width:1.5px] [&_path]:origin-center [&_path]:scale-125';
  }
});
</script>
